import React from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ArrowUpRight, BadgeCheck } from "lucide-react";
import { HERO_IMG } from "./constants";

export default function LandingHero({ metrics, onDemo }) {
  return (
    <section className="border-b border-zinc-200 bg-gradient-to-b from-stone-50 to-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-16 lg:py-24 grid lg:grid-cols-2 gap-12 items-center">
        <div>
          <div className="text-[11px] uppercase tracking-[0.22em] text-zinc-500 mb-4">Hospitality Intelligence Network</div>
          <h1 className="font-display font-black tracking-tight text-5xl lg:text-7xl leading-[0.95]" data-testid="hero-headline">
            Know Ahead.<br />
            <span className="text-teal">Stay Prepared.</span>
          </h1>
          <p className="mt-6 text-lg text-zinc-700 max-w-xl leading-relaxed">
            GuestIntel helps hospitality businesses share verified incident intelligence, reduce property losses, and make informed operational decisions through a trusted network of participating properties.
          </p>
          <div className="mt-8 flex flex-wrap gap-3" data-testid="hero-ctas">
            <Button onClick={onDemo} className="rounded-full" size="lg" data-testid="hero-demo-btn">
              Request Demo <ArrowUpRight className="w-4 h-4 ml-1" />
            </Button>
            <a href={`${process.env.REACT_APP_APP_URL || ""}/register`} target="_blank" rel="noopener noreferrer"><Button variant="outline" className="rounded-full" size="lg" data-testid="hero-join-btn">Join the Network</Button></a>
            <a href={`${process.env.REACT_APP_APP_URL || ""}/register`} target="_blank" rel="noopener noreferrer"><Button variant="ghost" className="rounded-full" size="lg" data-testid="hero-founding-btn">Become a Founding Property</Button></a>
          </div>
          {metrics && (
            <div className="mt-10 grid grid-cols-3 gap-6 max-w-md text-sm">
              <div>
                <div className="font-display font-black text-2xl">{metrics.total_records?.toLocaleString() ?? "—"}</div>
                <div className="text-xs uppercase tracking-widest text-zinc-500 mt-1">Records protected</div>
              </div>
              <div>
                <div className="font-display font-black text-2xl">{metrics.appeals_resolved ?? "—"}</div>
                <div className="text-xs uppercase tracking-widest text-zinc-500 mt-1">Appeals reviewed</div>
              </div>
              <div>
                <div className="font-display font-black text-2xl">{metrics.encryption_enabled ? "AES" : "—"}</div>
                <div className="text-xs uppercase tracking-widest text-zinc-500 mt-1">Encrypted at rest</div>
              </div>
            </div>
          )}
        </div>
        <div className="relative">
          <img src={HERO_IMG} alt="Hotel front desk manager reviewing the GuestIntel dashboard" className="w-full h-[420px] lg:h-[520px] object-cover rounded-lg shadow-2xl" />
          <div className="absolute -bottom-6 -left-6 hidden lg:block bg-white border border-zinc-200 rounded-md shadow-xl p-4 w-72">
            <div className="flex items-center gap-2 text-xs uppercase tracking-widest text-emerald-700"><BadgeCheck className="w-3.5 h-3.5" /> Intel Match</div>
            <div className="mt-2 font-display font-bold text-lg">Reservation #4218</div>
            <div className="text-sm text-zinc-700 mt-1">Verified record on file. 2 prior incidents at participating properties.</div>
            <div className="mt-2 text-xs text-zinc-500">Front desk · Tonight, 19:42</div>
          </div>
        </div>
      </div>
    </section>
  );
}
